module.exports = __webpack_public_path__ + "img/logo.67c7f1dd.svg";